import { ReceivingFileJoinedInterface } from 'skladon-types';

import { FileType } from 'src/types/file';
import { ReceivingType } from 'src/types/receiving';

/** Sloupec `receivings_files.DESCRIPTION` (MySQL varchar). */
export const RECEIVING_FILE_DESCRIPTION_MAX_LENGTH = 500;

/** U příjmu vždy ukládáme typ `other` (UI typ nevybíráme). */
export const RECEIVING_FILE_ATTACHMENT_TYPE = 'other' as const;

export function receivingJoinedToFiles(rows?: ReceivingFileJoinedInterface[]): FileType[] {
    if (!rows?.length) {
        return [];
    }
    return rows.map((r) => ({
        id: r.FILE_ID,
        fileName: r.ORIGINAL_FILE_NAME,
        fileType: r.FILE_TYPE,
        fileSize: r.FILE_SIZE,
        type: RECEIVING_FILE_ATTACHMENT_TYPE,
        description:
            r.DESCRIPTION != null
                ? String(r.DESCRIPTION).slice(0, RECEIVING_FILE_DESCRIPTION_MAX_LENGTH)
                : undefined,
        creatorRole: r.CREATOR_ROLE ?? undefined,
        createdAt: r.CREATED_AT ?? undefined,
    }));
}

/** API payload uses RECEIVING_FILES; form state uses FILES for FileUpload. */
export function receivingApiToEditData(data: ReceivingType): ReceivingType {
    const next: ReceivingType = { ...data };
    const rf = next.RECEIVING_FILES;
    if ('RECEIVING_FILES' in next) {
        delete (next as { RECEIVING_FILES?: ReceivingFileJoinedInterface[] }).RECEIVING_FILES;
    }
    next.FILES = receivingJoinedToFiles(rf);
    return next;
}
